module.exports = __webpack_public_path__ + "static/media/landing_banner2.d755d9eb.png";